import Loadable from 'react-loadable';
import { loading } from './loading';
import { NoComponent } from './nocomponent';

export type ViewType<P> = React.FunctionComponent<P> & Loadable.LoadableComponent;
export type Registry<P> = Record<string, ViewType<P>>;
export type RegistryFunc<P> = ($componentName: string) => ViewType<P>;

const BrandsPage = Loadable({
  loader: () =>
    import(
      /*webpackChunkName: "brandspage"*/ /* webpackMode: "lazy" */ 'views/BrandsPage/BrandsPage'
    ),
  loading,
  timeout: 10000
});

const Campaign3Page = Loadable({
  loader: () =>
    import(
      /*webpackChunkName: "campaign3page"*/ /* webpackMode: "lazy" */ 'views/Campaign3Page/Campaign3Page'
    ),
  loading,
  timeout: 10000
});

const CategoryPage = Loadable({
  loader: () =>
    import(
      /*webpackChunkName: "categorypage"*/ /* webpackMode: "lazy" */ 'views/CategoryPage/CategoryPage'
    ),
  loading,
  timeout: 10000
});

const CheckoutPage = Loadable({
  loader: () =>
    import(
      /*webpackChunkName: "checkoutpage"*/ /* webpackMode: "lazy" */ 'views/CheckoutPage/CheckoutPage'
    ),
  loading,
  timeout: 10000
});

const ConservatoryPage = Loadable({
  loader: () =>
    import(
      /*webpackChunkName: "conservatorypage"*/ /* webpackMode: "lazy" */ 'views/ConservatoryPage/ConservatoryPage'
    ),
  loading,
  timeout: 10000
});

const ContactPage = Loadable({
  loader: () =>
    import(
      /*webpackChunkName: "contactpage"*/ /* webpackMode: "lazy" */ 'views/ContactPage/ContactPage'
    ),
  loading,
  timeout: 10000
});

const ContentPage = Loadable({
  loader: () =>
    import(
      /*webpackChunkName: "contentpage"*/ /* webpackMode: "lazy" */ 'views/ContentPage/ContentPage'
    ),
  loading,
  timeout: 10000
});
const CustomerPage = Loadable({
  loader: () =>
    import(
      /*webpackChunkName: "customerpage"*/ /* webpackMode: "lazy" */ 'views/CustomerPage/CustomerPage'
    ),
  loading,
  timeout: 10000
});
const EditorialPage = Loadable({
  loader: () =>
    import(
      /*webpackChunkName: "editorialpage"*/ /* webpackMode: "lazy" */ 'views/EditorialPage/EditorialPage'
    ),
  loading,
  timeout: 10000
});
const FavouritesPage = Loadable({
  loader: () =>
    import(
      /*webpackChunkName: "favouritespage"*/ /* webpackMode: "lazy" */ 'views/FavouritesPage/FavouritesPage'
    ),
  loading,
  timeout: 10000
});
const FormPage = Loadable({
  loader: () =>
    import(/*webpackChunkName: "formpage"*/ /* webpackMode: "lazy" */ 'views/FormPage/FormPage'),
  loading,
  timeout: 10000
});
const InstallationPage = Loadable({
  loader: () =>
    import(
      /*webpackChunkName: "installationpage"*/ /* webpackMode: "lazy" */ 'views/InstallationPage/InstallationPage'
    ),
  loading,
  timeout: 10000
});
const KnowledgebasePage = Loadable({
  loader: () =>
    import(
      /*webpackChunkName: "knowledgebasepage"*/ /* webpackMode: "lazy" */ 'views/KnowledgebasePage/KnowledgebasePage'
    ),
  loading,
  timeout: 10000
});
const OurStoreListPage = Loadable({
  loader: () =>
    import(
      /*webpackChunkName: "ourstorelistpage"*/ /* webpackMode: "lazy" */ 'views/OurStores/OurStoreListPage'
    ),
  loading,
  timeout: 10000
});
const OurStorePage = Loadable({
  loader: () =>
    import(
      /*webpackChunkName: "ourstorepage"*/ /* webpackMode: "lazy" */ 'views/OurStores/OurStorePage'
    ),
  loading,
  timeout: 10000
});
const PpiPage = Loadable({
  loader: () =>
    import(/*webpackChunkName: "ppipage"*/ /* webpackMode: "lazy" */ 'views/PPI/PpiPage'),
  loading,
  timeout: 10000
});
const ProductlistPage = Loadable({
  loader: () =>
    import(
      /*webpackChunkName: "productlistpage"*/ /* webpackMode: "lazy" */ 'views/ProductlistPage/ProductlistPage'
    ),
  loading,
  timeout: 10000
});
const ProductPage = Loadable({
  loader: () =>
    import(
      /*webpackChunkName: "productpage"*/ /* webpackMode: "lazy" */ 'views/ProductPage/ProductPage'
    ),
  loading,
  timeout: 10000
});
const ProStorePage = Loadable({
  loader: () =>
    import(
      /*webpackChunkName: "prostorepage"*/ /* webpackMode: "lazy" */ 'views/ProStore/ProStorePage'
    ),
  loading,
  timeout: 10000
});
const SearchProductlistPage = Loadable({
  loader: () =>
    import(
      /*webpackChunkName: "searchproductlistpage"*/ /* webpackMode: "lazy" */ 'views/SearchProductlistPage/SearchProductlistPage'
    ),
  loading,
  timeout: 10000
});
const SectionPage = Loadable({
  loader: () =>
    import(
      /*webpackChunkName: "sectionpage"*/ /* webpackMode: "lazy" */ 'views/SectionPage/SectionPage'
    ),
  loading,
  timeout: 10000
});
const SurveyVotePage = Loadable({
  loader: () =>
    import(
      /*webpackChunkName: "surveyvotepage"*/ /* webpackMode: "lazy" */ 'views/SurveyVotePage/SurveyVotePage'
    ),
  loading,
  timeout: 10000
});
const UpdateEmailPage = Loadable({
  loader: () =>
    import(
      /*webpackChunkName: "updateemailpage"*/ /* webpackMode: "lazy" */ 'views/UpdateEmailPage/UpdateEmailPage'
    ),
  loading,
  timeout: 10000
});
const OrderPage = Loadable({
  loader: () =>
    import(/*webpackChunkName: "orderpage"*/ /* webpackMode: "lazy" */ 'views/OrderPage/OrderPage'),
  loading,
  timeout: 10000
});
const HelpCenterPage = Loadable({
  loader: () =>
    import(
      /*webpackChunkName: "helpcenterpage"*/ /* webpackMode: "lazy" */ 'views/HelpCenterPage/HelpCenterPage'
    ),
  loading,
  timeout: 10000
});

export const pageViews = {
  BrandsPage,
  Campaign3Page,
  CategoryPage,
  CheckoutPage,
  ConservatoryPage,
  ContactPage,
  ContentPage,
  CustomerPage,
  EditorialPage,
  FavouritesPage,
  FormPage,
  InstallationPage,
  KnowledgebasePage,
  OurStoreListPage,
  OurStorePage,
  PpiPage,
  ProductlistPage,
  ProductPage,
  ProStorePage,
  SearchProductlistPage,
  SectionPage,
  SurveyVotePage,
  UpdateEmailPage,
  OrderPage,
  HelpCenterPage
} as Registry<unknown>;

export function registry<P>($componentName: string): ViewType<P> {
  return pageViews[$componentName] || NoComponent;
}
